import React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import twitter from "../../images/abouttwitter.png";
import zoom from "../../images/aboutzoom.png";
import insta from "../../images/aboutinsta.png";
import maps from "../../images/location.png";

import Trial from "../../sections/Bookfreetrial/Trial";
import Footer from "../../sections/Footer/Footer";
import Header from "../../sections/Header/Header";
import TitlepicContact from "../../sections/TitlepicContact/TitlepicContact";
import Location from "../Contact/Maps";

import {
  GoogleMap,
  InfoWindow,
  Marker,
  GoogleApiWrapper,
} from "google-maps-react";

const Contact = () => {
  return (
    <div>
      <Header />
      <TitlepicContact />
      <div className="QL__PG__Contact">
        <Container>
          <Grid container spacing={8}>
            <Grid item xs={12} md={6}>
              <h1 className="HeadingAll">Send Us Message</h1>

              <form action="" className="Contactform">
                <div className="QL__PG__Contact__form">
                  <div className="QL__PG__COntact__FomrName">
                    <label htmlFor="username">Name:</label>
                  </div>

                  <input
                    className="QL__PG__Contact__formField"
                    type="text"
                    name="username"
                    id="username"
                    placeholder="Enter name"
                  />
                </div>
                <div className="QL__PG__Contact__form">
                  <div className="QL__PG__COntact__FomrName">
                    <label htmlFor="email">Email:</label>
                  </div>

                  <input
                    className="QL__PG__Contact__formField"
                    type="text"
                    name="email"
                    id="email"
                    placeholder="Enter email"
                  />
                </div>
                <div className="QL__PG__Contact__form">
                  <div className="QL__PG__COntact__FomrName">
                    <label htmlFor="phone">Phone Number:</label>
                  </div>
                  <input
                    className="QL__PG__Contact__formField"
                    type="number"
                    name="phonenumber"
                    id="phonenumber"
                    placeholder="Phone Number"
                  />
                </div>
                <div className="QL__PG__Contact__form">
                  <div className="QL__PG__COntact__FomrName">
                    <label htmlFor="country">Country:</label>
                  </div>

                  <input
                    className="QL__PG__Contact__formField"
                    type="text"
                    name="country"
                    id="country"
                    placeholder="e.g.newyork"
                  />
                </div>
              </form>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="QL___PG___Sec__Aboutmsg">
                <h1 className="HeadingAll">Contact Info</h1>
                <Typography paddingTop={3.5} fontWeight={600} fontSize={20}>
                  Address: Pakistan
                </Typography>
                <Typography fontWeight={600} fontSize={20} paddingTop={0.3}>
                Phone No: +447748343503
                </Typography>
                <Typography fontWeight={600} fontSize={20} paddingTop={0.3}>
                  Zoom: LQQZOOM
                </Typography>
                <Typography fontWeight={600} fontSize={20} paddingTop={0.3}>
                  Email: info@learnquranquick.com
                </Typography>
                <div class="Contact_links">
                  <a href="#">
                    <i>
                      <img className="QL__PG__Contact__Links" src={zoom} />
                    </i>
                  </a>
                  <a href="https://twitter.com/quranschool57">
                    <i>
                      <img className="QL__PG__Contact__Links" src={twitter} />
                    </i>
                  </a>
                  <a href="https://www.instagram.com/learnquranquick/">
                    <i>
                      <img className="QL__PG__Contact__Links" src={insta} />
                    </i>
                  </a>
                </div>
              </div>
              <img className="map" src={maps} />
              {/* <Location /> */}
            </Grid>
          </Grid>
        </Container>
      </div>

      <Trial />
      <Footer />
    </div>
  );
};
export default Contact;
